'use strict';

(function () {

  angular.module('specsguardApp')
    .config(InputConfig);

  InputConfig.$inject = ['$stateProvider'];

  function InputConfig ($stateProvider) {

    $stateProvider

      .state('tech_element', {
        url: '/tech_element',
        templateUrl: 'app-legacy/tech-element/tech-element.html',
        controller: 'TechElementCtrl',
        menu: {
          context: 'technical_template',
          title: '[Technical_templates]',
          subtitle: '[Technische specificaties]',
          icon: 'folder_empty'
        },
        authenticate: true,
        needRole: 7,
        resolve: {
          technicalElements: ['TechnicalElementsAPI', function (TechnicalElementsAPI) {
            return TechnicalElementsAPI.getFull().$promise;
          }],
          constants: ['Constants', function (Constants) {
            return Constants.getConstants();
          }]
        }
      });
  }

})();
